import { FC } from 'react';
import { Title, Container, NavLink as NavigationLink } from './Styled';

export interface LocationDescriptorObject {
    pathname: string;
    search?: string;
    hash?: string;
    state?: object;
}

export type LocationFunction = (
    location: LocationDescriptorObject
) => LocationDescriptorObject;

export interface NavigationDrawerLinkProps {
    to: string;
    title: string;
    Icon: React.FC;
}

export const NavLink: FC<NavigationDrawerLinkProps> = ({ to, Icon, title }) => {
    return (
        <NavigationLink to={to}>
            <Container>
                <Icon />
                <Title>{title}</Title>
            </Container>
        </NavigationLink>
    );
};
